import { DELETE_SLOT_ENTRY_URL, SERVE_ROOT } from "../Api"
import BeatLoader from "react-spinners/BeatLoader"
import "./SoundboardSlots.css"

const getButtonAction = (edit, soundFullPath, onDeleteSlot, slotPosition, showError) => {
    if(edit) {
        return () => { onDeleteSlot(slotPosition) }
    } else {
        const audioToPlay = new Audio(soundFullPath)
        return () => {
            const played = audioToPlay.played
            if(played.length > 0) {
                try {
                    audioToPlay.fastSeek(0)
                } catch(e) {}
            }
            audioToPlay.play()
            .then(()=>{})
            .catch(err=>{ showError(`Unable to play sound file: ${err}`) })
        }
    }
}

const getSlot = (slotPosition, mappedSounds, deleting, onDeleteSlot, showError, setRedirect, edit) => {
    const key = `slot${slotPosition}`
    if(slotPosition in mappedSounds) {
        const ds = mappedSounds[slotPosition]
        const soundFileName = ds.soundFile
        const soundFullPath = `${SERVE_ROOT}${soundFileName}`

        const iconFileName = ds.iconFile
        const iconFullPath = `${SERVE_ROOT}${iconFileName}`
        if(deleting) { // don't allow deleting while another is already deleting for now, until implementing a safe solution for it
            if(deleting === slotPosition) {
                return (
                    <div key={key} className="soundSlotLoadedDuringDelete">
                        <div className="loaderContainer">
                            <BeatLoader/>
                        </div>
                    </div>)
            } else {
                return (
                    <div key={key} className="soundSlotLoadedDuringDelete">
                        <img src={iconFullPath} alt={"Click me!"}/>
                    </div>)
            }
        } else {
            const buttonAction = getButtonAction(edit, soundFullPath, onDeleteSlot, slotPosition, showError)
            return (
                <div key={key} className="soundSlotLoaded" onClick={buttonAction}>
                    <img src={iconFullPath} alt={"Click me!"}/>
                </div>)
        }
    } else {
        return (<div key={key} className="soundSlotEmpty" onClick={()=>{setRedirect(slotPosition)}}>Not Set</div>)
    }
}

export const SoundboardSlots = (soundboardPositions, dashboardEntries, edit, onDeleteSlot, setRedirect, showError, deleting) => {
    const mappedSounds = {}
    dashboardEntries.forEach((e)=>{
        mappedSounds[e.position] = e
    })

    const slots = []
    soundboardPositions.forEach((sp)=>{
        const slot = getSlot(sp.slot, mappedSounds, deleting, onDeleteSlot, showError, setRedirect, edit)
        slots.push(slot)
    })
    return slots
}

export const deleteSlotEntry = (slotName, accessToken, onDeleteComplete, showError) => {
    const data = new FormData()
    data.append('slotName', slotName)
    fetch(DELETE_SLOT_ENTRY_URL, {
        method: 'post',
        headers: {'Authorization':`Bearer ${accessToken}`},
        body: data
    })
    .then(response=>{
        if (!response.ok) {
            const error = new Error(`Network response was not ok: ${response.status}`)
            error.response = response
            throw error
        } else {
            return response.json()
        }
    }).then(()=>{
        onDeleteComplete()
    })
    .catch((err)=>{
        if(err.response === undefined) {
            showError("An unexpected error occurred. Please check your internet connection and try again!")
        } else if(err.response.status === 500 || err.response.status === 403) {
            showError(`${err}: ${err.response.statusText}`)
        } else {
            err.response.json()
            .then((json)=>{
                showError(`${err}: ${json.status}`)
            })
        }
    })
}
